<div
  class="date-container"
  [class.au]="businessUnit() === BusinessUnit.AU"
  [style.border-color]="showBorderError() ? borderColor : ''"
  (focusin)="handleFocusin()"
  (focusout)="handleFocusout($event)"
>
  @if (businessUnit() === BusinessUnit.AU) {
    <label
      class="label"
      [for]="labelId"
      [ngClass]="{
        'mandatory-before': isMandatory() && asteriskPosition() === 'before',
        'mandatory-after': isMandatory() && asteriskPosition() === 'after'
      }"
    >
      {{ placeholder() }}
    </label>
  }
  <main [class.au]="businessUnit() === BusinessUnit.AU">
    <div class="input-label" [attr.data-label]="dayLabel">
      @for (day of days(); track $index) {
        <input
          #inputField
          class="day"
          type="text"
          autocomplete="off"
          inputmode="numeric"
          maxlength="1"
          pattern="[0-9]*"
          pcAutoDeletePrevious
          pcAutoFocusFirstEmpty
          pcAutoFocusNext
          pcNumbersOnly
          [appNumbersOnly]="true"
          [attr.aria-label]="dateContext ? dateContext + dayLabel : dayLabel"
          [class.au-input]="businessUnit() === BusinessUnit.AU"
          [class.border-bottom]="businessUnit() === BusinessUnit.IL"
          [disabled]="disabled()"
          [id]="labelId"
          [index]="$index"
          [name]="day.key"
          [placeholder]="businessUnit() === BusinessUnit.AU ? 'D' : ''"
          (input)="combineDate()"
          (keydown)="navigateDateInput($event, $index)"
          [(ngModel)]="day.value"
        />
      }
    </div>
    <span [class.au-input-slash]="businessUnit() === BusinessUnit.AU"> / </span>
    <div class="input-label" [attr.data-label]="monthLabel" (focusin)="setDefaultDate('days')">
      @for (month of months(); track $index) {
        <input
          #inputField
          class="month"
          type="text"
          autocomplete="off"
          inputmode="numeric"
          maxlength="1"
          pattern="[0-9]*"
          pcAutoDeletePrevious
          pcAutoFocusFirstEmpty
          pcAutoFocusNext
          pcNumbersOnly
          [appNumbersOnly]="true"
          [attr.aria-label]="dateContext ? dateContext + monthLabel : monthLabel"
          [class.au-input]="businessUnit() === BusinessUnit.AU"
          [class.border-bottom]="businessUnit() === BusinessUnit.IL"
          [disabled]="disabled()"
          [index]="$index + 2"
          [name]="month.key"
          [placeholder]="businessUnit() === BusinessUnit.AU ? 'M' : ''"
          (input)="combineDate()"
          (keydown)="navigateDateInput($event, $index + 2)"
          [(ngModel)]="month.value"
        />
      }
    </div>
    <span [class.au-input-slash]="businessUnit() === BusinessUnit.AU"> / </span>
    <div class="input-label" [attr.data-label]="yearLabel" (focusin)="setDefaultDate('months')">
      @for (year of years(); track $index) {
        <input
          #inputField
          class="year"
          type="text"
          autocomplete="off"
          inputmode="numeric"
          maxlength="1"
          pattern="[0-9]*"
          pcAutoDeletePrevious
          pcAutoFocusFirstEmpty
          pcAutoFocusNext
          pcNumbersOnly
          [appNumbersOnly]="true"
          [attr.aria-label]="dateContext ? dateContext + yearLabel : yearLabel"
          [class.au-input]="businessUnit() === BusinessUnit.AU"
          [class.border-bottom]="businessUnit() === BusinessUnit.IL"
          [disabled]="disabled()"
          [index]="$index + 4"
          [name]="year.key"
          [placeholder]="businessUnit() === BusinessUnit.AU ? 'Y' : ''"
          (input)="combineDate()"
          (keydown)="navigateDateInput($event, $index + 4)"
          [(ngModel)]="year.value"
        />
      }
    </div>
  </main>
</div>
